import { action, makeObservable, observable } from 'mobx';
import type { IAvailablePhases, IPhaseInfo, NamedParams } from '@/engine/app/CasePhaseData/interfaces.ts';
import { PhaseInfo } from '@/engine/app/CasePhaseData/PhaseInfo/PhaseInfo.ts';

export class AvailablePhases implements IAvailablePhases {
  @observable
  public list: Array<IPhaseInfo> = [];

  public constructor() {
    makeObservable(this);
  }

  @action
  public add(id: string, name: string, params?: NamedParams): IPhaseInfo {
    const info = new PhaseInfo(id, name, params);
    this.list.push(info);
    return info;
  }
}
